import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ListeArticles from "./ListeArticles";
import {
  listeArticlesParFamille,
  listeAllArticlesParFamille,
} from "../actions/articlesActions";
import { ParamParCliAction } from "../actions/paramAppActions";
import "../ArticlesParFamille.css";

const ArticlesParFamille = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { itemId, libelle, langue, wcli } = location.state || {};

  const larticles = useSelector((state) => state.articleListe);
  const paramCli = useSelector((state) => state.mesParams);
  const { params, erreur } = paramCli;
  const { articles } = larticles;
  const Cl = useSelector((state) => state.client);
  const { client } = Cl;
  const aFamille = useSelector((state) => state.articleFamille);
  const { articlesF, loading } = aFamille;
  const chariot = useSelector((state) => state.chariot);
  const { chariotListe, loadCh, varGlo, total } = chariot;
  const [rech, setRech] = useState("");
  const [artRech, setArtRech] = useState([]);
  const [N, setN] = useState("");

  const paramFiltre = () => {
    const res = params?.find(
      (p) => p.code_param == "FILTRE" && p.client == client?._id
    );
    return res?.valeur || false;
  };

  useEffect(() => {
    document.title = langue === "F" ? libelle : `عائلة: ${libelle}`;

    if (!client) {
      navigate("/");
      return;
    }

    setArtRech([]);
    setN("");

    if (rech === "") {
      if (client?.nivcli_cloud === "F") {
        dispatch(listeArticlesParFamille(itemId));
      } else if (client?.nivcli_cloud === "R" && paramFiltre()) {
        dispatch(listeArticlesParFamille(itemId));
      } else {
        dispatch(listeAllArticlesParFamille(itemId));
      }
    }

    const total = chariotListe?.reduce((acc, i) => acc + i.prix_total, 0) || 0;
    setN(total.toFixed(3));
  }, [client, rech, itemId]);

  useEffect(() => {
    if (rech.length > 0) {
      const filtered = articlesF?.filter((artF) =>
        artF.nom.toUpperCase().includes(rech.toUpperCase())
      );
      setArtRech(filtered || []);
    }
  }, [rech, articlesF]);

  const renderItem = (articleF) => (
    <div className="article-item-container">
      <ListeArticles
        article={articleF}
        client={client}
        langue={langue}
        source="F"
        wcli={varGlo || client}
      />
    </div>
  );

  return (
    <div className="articles-container">
      <div className="search-container">
        <input
          type="text"
          placeholder="Rechercher article"
          value={rech}
          onChange={(e) => setRech(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="articles-grid">
          {(artRech.length > 0 ? artRech : articlesF)?.map((article) =>
            renderItem(article)
          )}
        </div>
      )}
    </div>
  );
};

export default React.memo(ArticlesParFamille);
